import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { nextTick, ref } from 'vue';
import { EnumIroType, useAddIroMutation, useAddIroSectionLinkMutation, useAddIroStakeholderLinkMutation, useListIrosQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'AddIro',
  props: {
    activityId: {
      type: String,
      required: false,
      default: ''
    },
    esrsId: {
      type: Number,
      required: false,
      default: null
    },
    limitTo: {
      type: String,
      required: false,
      default: '',
      validator: function validator(value) {
        return ['impacts', 'financial', ''].includes(value);
      }
    }
  },
  emits: ['done'],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
      emit = _ref.emit;
    var props = __props;
    var name = ref('');
    var _useAddIroMutation = useAddIroMutation(),
      addIro = _useAddIroMutation.mutate,
      loading = _useAddIroMutation.loading;
    var type = ref();
    var attrs = useAttrs();
    var _useAddIroStakeholder = useAddIroStakeholderLinkMutation(),
      addIroStakeholderLink = _useAddIroStakeholder.mutate;
    var _useAddIroSectionLink = useAddIroSectionLinkMutation(),
      addIroSectionLink = _useAddIroSectionLink.mutate;
    var _useListIrosQuery = useListIrosQuery({
        input: {
          notLinkedToStakeholderIds: attrs['stakeholder-id'] ? [attrs['stakeholder-id']] : []
        }
      }),
      result = _useListIrosQuery.result,
      refetch = _useListIrosQuery.refetch;
    expose({
      refetch: refetch
    });
    var iros = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listIros;
    }); // iros that are not linked to current stakeholder

    var activityIdToLink = ref(''); // used (like in ESRS list view) when we create an IRO before attaching an activity to it.

    var search = ref('');
    var onChange = function onChange(e) {
      // when a valid stakeholder is clicked, link it!
      addIroStakeholderLink({
        stakeholderId: attrs['stakeholder-id'],
        iroId: e
      }).then(function () {
        emit('done');
        search.value = '';
        refetch();
      });
    };
    var infoDialog = ref(false);

    // this part handles the case when IROs can NOT be found, we open the menu and focus the name field.
    var nameRef = ref(null);
    var menuModel = ref(false);
    var createIro = function createIro() {
      if (name.value.length > 0 && [EnumIroType.PositiveImpact, EnumIroType.NegativeImpact, EnumIroType.Risk, EnumIroType.Opportunity].includes(type.value)) {
        var input = {
          iro: {
            name: name.value,
            type: type.value,
            activityId: props.activityId || activityIdToLink.value,
            stakeholderId: attrs['stakeholder-id']
          }
        };
        addIro(input).then(function (response) {
          var _response$data, _response$data$addIro;
          var iroId = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$addIro = _response$data.addIro) === null || _response$data$addIro === void 0 ? void 0 : _response$data$addIro.id;
          if (iroId && props.esrsId) {
            // If we are creating the IRO from the ESRS list screen, link it to the ESRS section.
            addIroSectionLink({
              input: {
                iroId: iroId,
                sectionId: props.esrsId
              }
            });
          }
          name.value = '';
          menuModel.value = false;
          emit('done');
        });
      }
    };
    var onKeyDown = function onKeyDown(e) {
      if (e.code === 'Enter') {
        if (!menuModel.value) {
          menuModel.value = true;
          name.value = search.value;
          search.value = '';
          nextTick(function () {
            if (nameRef.value) {
              nameRef.value.focus();
            }
          });
        } else {
          createIro();
        }
      }
    };
    var availableTypes = computed(function () {
      if (props.limitTo === 'impacts') {
        return [EnumIroType.PositiveImpact, EnumIroType.NegativeImpact];
      } else if (props.limitTo === 'financial') {
        return [EnumIroType.Risk, EnumIroType.Opportunity];
      }
      return [EnumIroType.PositiveImpact, EnumIroType.NegativeImpact, EnumIroType.Risk, EnumIroType.Opportunity];
    });
    return {
      __sfc: true,
      name: name,
      addIro: addIro,
      loading: loading,
      props: props,
      type: type,
      attrs: attrs,
      addIroStakeholderLink: addIroStakeholderLink,
      addIroSectionLink: addIroSectionLink,
      result: result,
      refetch: refetch,
      iros: iros,
      activityIdToLink: activityIdToLink,
      search: search,
      emit: emit,
      onChange: onChange,
      infoDialog: infoDialog,
      nameRef: nameRef,
      menuModel: menuModel,
      createIro: createIro,
      onKeyDown: onKeyDown,
      availableTypes: availableTypes,
      EnumIroType: EnumIroType
    };
  }
});